export default "__VITE_ASSET__BCLWCs91__"